// extracted by mini-css-extract-plugin
export default {"wrapper":"donutChart_wrapper__0TCVq","label":"donutChart_label__RPsnl","donutChart":"donutChart_donutChart__pB3AX"};